// src/pages/MainBranch.jsx
import React from "react";
import { motion } from "framer-motion";
import img2 from "../components/about/img1.png";

const MainBranch = () => {
  return (
    <section className="py-20 bg-blue-200">
      <div className="max-w-7xl mx-auto flex flex-col items-center gap-12">
        {/* Top - Image */}
        <div className="w-full">
          <img
            src={img2}
            alt="Team working"
            className="w-full rounded-2xl object-cover shadow-lg"
          />
        </div>

        {/* Vision & Mission Section */}
        <motion.div
          className="bg-white text-gray-800 rounded-2xl shadow-xl p-10 w-full max-w-5xl"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl font-bold mb-4 flex items-center justify-center gap-2">
             Our Vision
          </h2>
          <p className="text-center text-lg leading-relaxed mb-4 font-medium">
            “To be a globally trusted name in precision components—powering motion,
            enabling innovation, and shaping the future of automotive and industrial
            engineering.”
          </p>
          <p className="text-center text-md leading-relaxed mb-6">
            We aim to be recognized not just as a manufacturer, but as a performance
            partner—valued for our commitment to quality, sustainability, and customer
            satisfaction.
          </p>

          <h2 className="text-3xl font-bold mb-4 flex items-center justify-center gap-2">
             Our Mission
          </h2>
          <p className="text-center text-lg leading-relaxed mb-4 font-medium">
            “To engineer world-class ball studs, sockets, and fasteners that drive
            reliability and safety—through advanced technology, zero-defect mindset,
            and customer-centric manufacturing.”
          </p>

          <p className="text-center text-md leading-relaxed mb-2 font-semibold">
            We strive to grow through:
          </p>
          <ul className="list-disc list-inside text-center text-md leading-relaxed space-y-1">
            <li>Continuous improvement in processes and productivity</li>
            <li>Scalable infrastructure and clean manufacturing practices</li>
            <li>
              Building strong, long-term partnerships with our clients across the globe
            </li>
          </ul>
        </motion.div>

        {/* Google Map Section */}
        <motion.div
          className="bg-white min-h-screen text-black flex items-center justify-center p-6 w-full"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <div className="w-full max-w-6xl h-[250px] sm:h-[350px] md:h-[450px] lg:h-[500px] rounded-lg overflow-hidden shadow-lg">
            <iframe
              title="Twin Star Industries Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5094.852035186591!2d80.24569130188264!3d12.969780072227499!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525d71b31b23bf%3A0xb036dd6f6e5f155c!2sTwin%20Star%20Industries!5e0!3m2!1sen!2sin!4v1755194160054!5m2!1sen!2sin"
              width="100%"
              height="100%"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default MainBranch;
